"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blobfileKeys = exports.blobfileKeyMap = exports.InvalidBlobNameError = exports.InvalidContainerError = void 0;
exports.getBlobName = getBlobName;
exports.safeContainerName = safeContainerName;
exports.safeBlobName = safeBlobName;
const dbschema_1 = require("@karya/dbschema");
const errors_1 = require("./errors");
const path_1 = __importDefault(require("path"));
var errors_2 = require("./errors");
Object.defineProperty(exports, "InvalidContainerError", { enumerable: true, get: function () { return errors_2.InvalidContainerError; } });
Object.defineProperty(exports, "InvalidBlobNameError", { enumerable: true, get: function () { return errors_2.InvalidBlobNameError; } });
/**
 * Return the blobname given the parameters and extension
 * @param params Name parameters for the blob name
 */
function getBlobName(params) {
    switch (params.cname) {
        case 'language-assets':
            return `${params.language_code}.${params.ext}`;
        case 'datapoint':
            return `${params.name}`;
        case 'report':
            return `${params.kind}-${params.id}-${params.params.join('-')}.${params.ext}`;
        case 'exports':
            return `${params.name}`;
        case 'audioprompts':
            return `${params.name}`;
        case 'conferencer':
            return `${params.conference_id}.${params.kind}.${params.ext}`;
        case 'worker-certificates':
            return `${params.name}`;
        case 'worker-profile-picture':
            return `${params.name}`;
        case 'worker-resume':
            return `${params.name}`;
        case 'form-data':
            return `${params.name}.${params.ext}`;
        case 'org-consent':
            return `${params.org_code}-${params.kind}.${params.ext}`;
    }
}
/**
 * List of keys that can appear in a blob file
 */
exports.blobfileKeyMap = {
    dataset_id: 'DS',
    datapoint_id: 'DP',
    task_id: 'T',
    microtask_id: 'MT',
    assignment_id: 'MTA',
    worker_id: 'W',
    avatar_id: 'A',
    key: 'K',
    suffix: 'R',
};
exports.blobfileKeys = [
    'dataset_id',
    'datapoint_id',
    'task_id',
    'microtask_id',
    'assignment_id',
    'worker_id',
    'avatar_id',
    'key',
    'suffix',
];
/**
 * Check if a value is a container name
 */
function isContainerName(cname) {
    return dbschema_1.containerNames.includes(cname);
}
/**
 * Return safe container name from an external input
 */
function safeContainerName(cname) {
    if (!isContainerName(cname)) {
        throw new errors_1.InvalidContainerError(cname);
    }
    return cname;
}
/**
 * Validates and returns a safe blob name from external input.
 * Removes any directory structure and rejects dangerous names (empty, '.', '..').
 * @param blobName Blob name from external input
 * @returns Sanitized blob name without directory components
 * @throws {InvalidBlobNameError} if blob name is empty, '.', or '..'
 */
function safeBlobName(blobName) {
    const safeName = path_1.default.basename(blobName);
    if (!safeName || safeName === '.' || safeName === '..') {
        throw new errors_1.InvalidBlobNameError(blobName);
    }
    return safeName;
}
//# sourceMappingURL=Index.js.map